import React from "react";
import { Outlet } from "react-router-dom";
export const MobileBreakage: React.FC = () => {
  return <Outlet />;
};
